import React from 'react';
import AdminLayout from '../../components/AdminLayout';
import { Box, Typography } from '@mui/material';

const Settings = () => {
  return (
    <AdminLayout>
      <Box>
        <Typography variant="h4" fontWeight={700} gutterBottom>
          Settings
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Settings functionality coming soon...
        </Typography>
      </Box>
    </AdminLayout>
  );
};

export default Settings;
